var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import FormInput from '@/common/components/Form/FormInput.vue';
import FormRadio from '@/common/components/Form/FormRadio.vue';
import FormDatePicker from '@/common/components/Form/FormDatePicker.vue';
import SectionTitle from '@/common/components/SectionTitle/index.vue';
import { timeFormat } from '@/common/filters/index';
import { postSingleClue, getClueStatusOptions } from '@views/schedule/api/index';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { dateFns } from '@lhb/func';
var AddClueDialog = /** @class */ (function (_super) {
    __extends(AddClueDialog, _super);
    function AddClueDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.showDatePopover = false;
        _this.form = {
            status: 'INTENTION',
            name: '',
            boothId: null,
            dates: [],
        };
        _this.statusOptions = [];
        _this.rules = {};
        _this.today = new Date(dateFns.changeTime(new Date(), null, true) + " 00:00");
        return _this;
    }
    Object.defineProperty(AddClueDialog.prototype, "user", {
        get: function () {
            return this.$store.state.common.user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddClueDialog.prototype, "iconClass", {
        get: function () {
            return this.showDatePopover ? 'el-icon-arrow-up' : 'el-icon-arrow-down';
        },
        enumerable: false,
        configurable: true
    });
    AddClueDialog.prototype.mounted = function () {
        var _this = this;
        this.$refs.nameInput && this.$refs.nameInput.focus();
        getClueStatusOptions().then(function (res) {
            _this.statusOptions = res;
        });
    };
    AddClueDialog.prototype.clueInfoChange = function (newVal) {
        this.form.boothId = newVal.boothInfo.id;
        if (newVal.dates.length > 0) {
            this.form.dates = [newVal.dates[0], newVal.dates[newVal.dates.length - 1]];
            if (!this.form.name && this.$refs.nameInput) {
                this.$refs.nameInput.focus();
            }
        }
        else {
            this.form.dates = [];
        }
    };
    AddClueDialog.prototype.blurHandle = function () {
        this.showDatePopover = false;
    };
    AddClueDialog.prototype.showDatePicker = function () {
        var _this = this;
        if (!this.showDatePopover) {
            this.showDatePopover = true;
            setTimeout(function () {
                _this.$refs.datePicker.focus();
            }, 50);
        }
    };
    AddClueDialog.prototype.changeHandle = function (e) {
        // this.showDatePopover = false;
        this.$emit('dateChange', e);
    };
    AddClueDialog.prototype.cancelHandle = function () {
        this.$emit('cancel');
    };
    AddClueDialog.prototype.submitHandle = function () {
        var _this = this;
        this.loading = true;
        window.LHBbigdata.send({
            event_id: 'a8b692d5-4ea9-489e-9ad4-095a74444340'
        });
        var _a = this.form, status = _a.status, boothId = _a.boothId, name = _a.name, dates = _a.dates;
        if (!name) {
            this.loading = false;
            return this.$message.warning('请输入活动名称～');
        }
        var params = {
            status: status,
            name: name,
            startAt: dates[0],
            endAt: dates[1],
            boothId: boothId,
        };
        postSingleClue(params).then(function (item) {
            _this.$message.success('预定成功～');
            _this.$emit('refresh', item);
        }).finally(function () {
            _this.loading = false;
        });
    };
    __decorate([
        Prop({
            type: Object,
            default: function () { },
        })
    ], AddClueDialog.prototype, "clueInfo", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () { return ({
                x: 0,
                y: 0,
            }); },
        })
    ], AddClueDialog.prototype, "layout", void 0);
    __decorate([
        Watch('clueInfo', {
            immediate: true,
            deep: true,
        })
    ], AddClueDialog.prototype, "clueInfoChange", null);
    AddClueDialog = __decorate([
        Component({
            filters: { timeFormat: timeFormat },
            components: {
                FormInput: FormInput,
                FormRadio: FormRadio,
                FormDatePicker: FormDatePicker,
                SectionTitle: SectionTitle,
            },
        })
    ], AddClueDialog);
    return AddClueDialog;
}(Vue));
export default AddClueDialog;
